import { render, staticRenderFns } from "./AddClientButton.vue?vue&type=template&id=231e6148&scoped=true"
import script from "./AddClientButton.vue?vue&type=script&lang=js"
export * from "./AddClientButton.vue?vue&type=script&lang=js"
import style0 from "./AddClientButton.vue?vue&type=style&index=0&id=231e6148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e6148",
  null
  
)

export default component.exports